module.exports = __webpack_public_path__ + "static-portal/img/new4-2.3560ed4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new4-2.png
// module id = aRfi
// module chunks = 4